// TODO find a way to share this with scss

export default {
    outerMargin: 16,
    innerMargin: 8,
    itemWidth: 320,
    toggleIconWidth: 46,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/modules/ticketsWidget/styleVars.ts